import { render, staticRenderFns } from "./CustomerBasicInfoSub.vue?vue&type=template&id=13594b14&scoped=true&"
import script from "./CustomerBasicInfoSub.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicInfoSub.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBasicInfoSub.vue?vue&type=style&index=0&id=13594b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13594b14",
  null
  
)

export default component.exports